<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      :before-close="handleClose"
      append-to-body
      width="600px"
    >
      <div class="dialog-common-xb">
        <el-form :model="item" :rules="rules" ref="form" label-width="100px">
          <el-form-item
            label="话题名称"
            prop="title"
            style="margin-bottom: 10px"
          >
            <el-input
              v-model="item.title"
              maxlength="30"
              placeholder="请输入1到30个字"
              size="medium"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面" prop="image" style="margin-bottom: 10px">
            <image-upload v-model="item.image"></image-upload>
          </el-form-item>
          <el-form-item
            label="角标"
            prop="subscript"
            style="margin-bottom: 0px; margin-top: 16px"
          >
            <el-input
              v-model="item.subscript"
              maxlength="4"
              placeholder="请输入1到4个字"
              style="width: 200px"
              size="medium"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="关联题主用户"
            prop="user"
            style="margin-bottom: 10px"
          >
            <!-- <span style="margin-right: 10px"> {{ user.nickname }}</span> -->
            <button
              class="btn btn-sm btn-primary"
              type="button"
              @click="chooseUser"
              v-if="!user.nickname"
            >
              选择
            </button>
            <button
              class="btn btn-sm btn-danger"
              type="button"
              @click="deleteUser"
              v-if="user.nickname"
            >
              删除
            </button>
            <div>
              <t-table
                size="medium"
                rowKey="id"
                v-if="user.nickname"
                :columns="tableColumns"
                :data="[user]"
                stripe
              ></t-table>
            </div>
          </el-form-item>
          <el-form-item
            label="题主简介"
            prop="description"
            style="margin-bottom: 10px"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 2 }"
              v-model="item.description"
              maxlength="150"
              placeholder="请输入1到150个字"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="状态"
            prop="showState"
            style="margin-bottom: 10px"
          >
            <el-radio-group v-model="item.showState" style="margin-top: 8px">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer">
        <button
          @click="handleClose()"
          class="btn btn-sm btn-outline-dark"
          type="button"
          style="margin-right: 10px"
        >
          取消
        </button>
        <button @click="save()" class="btn btn-sm btn-primary" type="button">
          确定
        </button>
      </div>
    </el-dialog>
    <user-dialog
      type="single"
      @pageCallback="pageCallback"
      ref="user"
    ></user-dialog>
    <!-- <media-dialog @pageCallback="pageCallback" ref="media"></media-dialog> -->
  </div>
</template>

<script>
import imageUpload from "@/components/imageUpload.vue";
import UserDialog from "@/components/userDialog/UserDialog.vue";
import { add, modify } from "@/server/api/topic.js";
export default {
  components: { imageUpload, UserDialog },
  data() {
    return {
      item: {
        id: "",
        title: "",
        image: "",
        userId: "",
        description: "",
        showState: 1,
      },
      rules: {
        title: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
        ],
        image: [
          {
            required: true,
            message: "请上传封面",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "请输入题主简介",
            trigger: "blur",
          },
        ],
      },
      currentMedia: {},
      title: "新建",
      show: false,
      user: {},
      tableColumns: [
        {
          colKey: "id",
          title: "ID",
          width: 100,
        },
        // {
        //   colKey: "phone",
        //   title: "手机",
        //   width: 110,
        //   cell: (h, { col, row }) => {
        //     return row.phone || "--";
        //   },
        // },
        {
          colKey: "nickname",
          title: "昵称",
          minWidth: 100,
          cell: (h, { col, row }) => {
            return row.nickname || "--";
          },
        },
        // {
        //   colKey: "enable",
        //   title: "状态",
        //   width: 80,
        //   cell: (h, { col, row }) => {
        //     return row.enable ? "正常" : "冻结";
        //   },
        // },
        // {
        //   colKey: "level",
        //   title: "等级",
        //   width: 80,
        // },
        // {
        //   colKey: "score",
        //   title: "积分",
        //   width: 90,
        // },
        // {
        //   colKey: "createdAt",
        //   title: "注册时间",
        //   width: 170,
        // },
      ],
    };
  },

  // props: {
  //   visible: {
  //     type: Boolean,
  //     default: true,
  //   },
  //   autoClose: {
  //     type: Boolean,
  //     default: true,
  //   },
  // },
  // watch: {
  //   visible(val) {
  //     this.show = val;
  //   },
  // },
  mounted() {
    console.log("加载了");
  },

  methods: {
    showModel(item) {
      this.init();
      if (item) {
        this.title = "编辑";
        this.item = this.another(item);
        if (item.userId) {
          this.user = {
            id: item.userId,
            nickname: item.nickName,
          };
          delete this.item.nickname;
        }
      } else {
        this.title = "新建";
      }
      this.show = true;
    },

    handleClose() {
      this.$refs.form.resetFields();
      this.show = false;
    },

    save() {
      this.$refs.form.validate((valid) => {
        console.log("校验结果", valid);
        if (valid) {
          let params = this.another(this.item);
          if (this.user.nickname) {
            params.userId = this.user.id;
          } else {
            delete params.userId;
          }
          params.mediaId = JSON.parse(localStorage.chosedMedia).id;
          console.log("保存参数", params);
          if (params.id) {
            modify(params).then((res) => {
              if (res.code === 0) {
                this.success("修改成功");
                this.$emit("change", "");
                this.handleClose();
              } else {
                this.warning(res.msg);
              }
            });
          } else {
            delete params.id;
            add(params).then((res) => {
              if (res.code === 0) {
                this.success("创建成功");
                this.$emit("change", "");
                this.handleClose();
              } else {
                this.warning(res.msg);
              }
            });
          }
        }
      });
      return;
      this.handleClose();
      this.$emit("pageCallback", current);
    },
    init() {
      this.title = "新建";
      this.item = {
        title: "",
        image: "",
        user: [],
        description: "",
        showState: 1,
      };
      this.user = {};
    },
    pageCallback(obj) {
      if (obj.code == "user") {
        this.user = obj.item[0];
      } else if (obj.code == "media") {
        this.item.userId = obj.item.id;
        this.currentMedia = obj.item;
      }
    },
    chooseUser() {
      this.$refs.user.showModel("选择题主");
    },
    deleteUser() {
      this.user = {};
    },
    selectMedia() {
      let userId = this.item.userId ? this.item.userId : "";
      console.log(userId);
      this.$refs.media.showModel(userId);
    },

    removeMedia() {
      this.item.userId = "";
      this.currentMedia = {};
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 10px 15px 0px;
  background-color: white;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
::v-deep .el-dialog {
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  position: relative !important;
  max-height: 95vh !important;
}

.dialog-common-xb {
  display: flex;
  flex-direction: column;
  max-height: calc(95vh - 141px); //内容高度
  overflow: auto;
}
::v-deep th {
  padding: 8px 8px 7px 8px;
  background-color: white;
}
::v-deep td {
  padding: 8px 8px 7px 8px;
}
.select-current-media {
  display: inline-block;
  width: auto;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  position: relative;
  padding-left: 3.2rem;
}

.select-current-media img {
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  left: 0.75rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
